<template>
  <div class="card">
    <div class="card-header">Dashboard Search</div>
    <div class="card-block">
      <SearchBar
        :total="total"
        @queryChanged="queryChanged"
        @searchTypeChanged="searchTypeChanged"
        @perPageChanged="perPageChanged"
      />
      <div class="card-block spinner-parent">
        <spinner ref="spinner" size="md" text="Loading ..." />
        <nav>
          <pager
            :total="total"
            :offset="offset"
            :size="perPage"
            @page-changed="$_changePage"
          />
        </nav>
        <div class="table-responsive">
          <table v-if="total" class="entities table table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Thumbnail</th>
                <th>Title</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in entities" :key="item._id + item._source.snippet.type" :data-id="item._id + item._source.snippet.type">
                <td>{{ item._source.id }}</td>
                <td class="table-list__cell--narrow text-center">
                  <img :src="item._source.snippet.thumb" alt="" style="max-height: 100px;">
                </td>
                <td>{{ item._source.snippet.title }}</td>
                <td>{{ item._source.snippet.type }}</td>
                <td class="table-list__cell--narrow">
                  <router-link
                    v-if="$_allowUpdating(item)"
                    class="btn btn-primary btn-sm"
                    :to="`content/${item._source.type}/edit/${item._source.id}`"
                  >
                    Edit
                  </router-link>
                  <open-on-site
                    :source-route="item._source.snippet.url"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="!isLoading && !searchQuery && total === 0">Your results will be displayed here</div>
        <div v-else-if="!isLoading && total === 0">There are no entities for your request</div>
        <nav>
          <pager
            :total="total"
            :offset="offset"
            :size="perPage"
            @page-changed="$_changePage"
          />
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import ListPageMixin from '@/mixins/ListPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';
import Pager from '@/global/components/Pager';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
import SearchBar from './SearchBar.vue';
import SEARCH_BY from './SearchBy';

export default {
  name: 'MainSearch',
  components: {
    pager: Pager,
    SearchBar,
    'open-on-site': OpenOnSiteButton,
  },
  mixins: [ListPageMixin, CommonPageMixin],
  data: () => ({
    searchQuery: '',
    searchType: SEARCH_BY.TITLE,
    isLoading: false,
  }),
  mounted() {
    this.perPage = 25;
  },
  methods: {
    getSource() {
      this.isLoading = true;
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = this.searchQuery;
      // const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;

      const getUrl = `${this.$config.app_api.prefix}search/documents`;
      const params = {
        offset: this.offset,
        limit: this.perPage,
      };

      switch (this.searchType) {
      case SEARCH_BY.ID: {
        if (searchString) {
          params.id = searchString;
        }
        break;
      }
      case SEARCH_BY.URL: {
        if (searchString) {
          params.url = searchString;
        }
        break;
      }
      case SEARCH_BY.BODY: {
        if (searchString) {
          params.body = searchString;
        }
        break;
      }
      case SEARCH_BY.TITLE:
      default: {
        if (searchString) {
          params.title = searchString;
        }
        break;
      }
      }

      this.$apiHttp.get(getUrl, {
        params,
      }).then((response) => {
        if (this.searchProcessId === searchProcessId) {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          const { data } = response;
          if (Array.isArray(data)) {
            this.entities = [];
            this.total = 0;
            this.isLoading = false;
            return;
          }
          this.entities = response.data.hits;
          this.total = data.total.value;
          this.isLoading = false;
        }
      }).catch((error) => {
        this.$_errorCallback(error);
        this.isLoading = false;
      });
    },
    queryChanged(query) {
      this.searchQuery = query;
    },
    searchTypeChanged(type) {
      this.searchType = type;
      this.getSource();
    },
    perPageChanged(val) {
      this.perPage = val;
      this.getSource();
    },
  },
};
</script>



// WEBPACK FOOTER //
// DashboardSearch.vue?248cdc51